module.exports = __webpack_public_path__ + "img/9791190422000.21db31da.jpg";